import React, { useState, useEffect } from 'react'
import DataTableDemo from '../../components/generals/datatables/datatable'
import { getData } from '../../actions/servicesHttp'
import store from '../../reducer/store'
import Header from '../../components/generals/header'
import stylesIndex from './../../css/Index.module.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Loading from '../../components/generals/loading'

export default function Establishments () {
  const { user } = store.getState()
  const { t, ready } = useTranslation('establishments')
  const navigate = useNavigate()
  const [establishments, setEstablishments] = useState(null)
  const role = user.roles

  const columns = [
    { field: 'code', header: t('headers.one') },
    { field: 'name', header: t('headers.two') },
    { field: 'level', header: t('headers.three') },
    { field: 'localOffice', header: t('headers.four') },
    { field: 'region', header: t('headers.five') },
    { field: 'address', header: t('headers.six') },
    { field: 'lon', header: t('headers.seven') },
    { field: 'lat', header: t('headers.eight') },
    { field: 'type', header: t('headers.nine') },
    { field: 'district', header: t('headers.ten') },
    { field: 'classrooms', header: t('headers.eleven') },
    { field: 'multifunctionalPrinter', header: t('headers.twelve') },
    { field: 'type1computer', header: t('headers.thirteen') },
    { field: 'type2computer', header: t('headers.fourteen') },
    { field: 'type3computer', header: t('headers.fifteen') },
    { field: 'tablet', header: t('headers.sixteen') },
    { field: 'screen', header: t('headers.seventeen') },
    { field: 'cabinet', header: t('headers.eighteen') }
  ]

  const getEstablishments = async () => {
    const response = await getData('establishments', undefined, navigate)
    if (response?.status === 200) {
      const data = response?.data
      data.forEach(element => {
        element.code = element.code === null ? t('noDisponible') : element.code
        element.localOffice = element.localOffice === null ? t('noDisponible') : element.localOffice
        element.name = element.name === null ? t('noDisponible') : element.name
        element.address = element.address === null ? t('noDisponible') : element.address
        element.lon = element.lon === null ? t('noDisponible') : element.lon
        element.lat = element.lat === null ? t('noDisponible') : element.lat
        element.type = element.type === null ? t('noDisponible') : element.type
        element.district = element.district === null ? t('noDisponible') : element.district
        element.classrooms = element.classrooms === null ? t('noDisponible') : element.classrooms
      })
      setEstablishments(data)
    } else {
      setEstablishments([])
    }
  }

  useEffect(() => {
    if (ready) {
      getEstablishments()
    }
  }, [ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        {establishments === null && <Loading color="primary" />}
        {establishments !== null && <DataTableDemo
          data={establishments}
          reload={null}
          editUsers={false}
          rowStates={false}
          rowSelecteds={false}
          exportsPdf={role?.establishmentsPage.exportPdf}
          exportsCsv={role?.establishmentsPage.exportCsv}
          actionDelete={false}
          actionDashboard={false}
          table="establishments"
          searchs={['level', 'region']}
          columns={columns}
          namePdf={t('namePdf')}
        />}
      </div>
    </div>
  )
}
